import { EWebimKey } from 'types/webim/webim-key.enum';

export const setWebimCookies = (sessionId: string | null, visitor: string | null): void => {
  const splitedHostname = window.location.hostname.split('.');
  splitedHostname.shift();
  const hostname = splitedHostname.join('.');
  document.cookie = `${EWebimKey.WEBIM_VISIT_SESSION_ID}=${btoa(sessionId || '')}; path=/; Domain=${hostname}; Secure; SameSite=strict`;
  document.cookie = `${EWebimKey.WEBIM_VISITOR}=${btoa(visitor || '')}; path=/; Domain=${hostname}; Secure; SameSite=strict`;
};
